import { combineReducers } from 'redux';
import loginReducer from './loginReducer';
import homeReducer from './homeReducer';
import rewardReducer from './rewardReducer';
import survay_historyReducer from './survay_historyReducer';
import referralReducer from './referralReducer';
import helpReducer from './helpReducer';
import profileReducer from './profileReducer';
import finished_pageReducer from './finished_pageReducer';
import profile_actvateReducer from './profile_actvateReducer';
import unsubscibe_pageReducer from './unsubscibe_pageReducer';
import newsArticleReducer from './newsArticleReducer';

const rootReducer = combineReducers({
  auth: loginReducer,
  home:homeReducer,
  rewards:rewardReducer,
  history:survay_historyReducer,
  referral:referralReducer,
  help:helpReducer,
  profile:profileReducer,
  survay_finished:finished_pageReducer,
  profile_actvate:profile_actvateReducer,
  profile_unsubscribe:unsubscibe_pageReducer,
  articles: newsArticleReducer,
});

export default rootReducer;
